import React from 'react'
import ContentLoader from 'react-content-loader'

const MyContentLoader = props => (
  <ContentLoader
    speed={2}
    width={800}
    height={600}
    viewBox="0 0 800 600"
    backgroundColor="#f2f5fa"
    foregroundColor="#ffffff"
    {...props}
  >
    <rect x="100" y="50" rx="4" ry="4" width="600" height="80" />
    <rect x="200" y="150" rx="4" ry="4" width="400" height="40" />
    <rect x="100" y="260" rx="4" ry="4" width="140" height="20" />
    <rect x="260" y="260" rx="4" ry="4" width="437" height="20" />
    <rect x="100" y="300" rx="4" ry="4" width="140" height="20" />
    <rect x="260" y="300" rx="4" ry="4" width="437" height="20" />
    <rect x="100" y="340" rx="4" ry="4" width="140" height="20" />
    <rect x="260" y="340" rx="4" ry="4" width="437" height="20" />
    <rect x="100" y="380" rx="4" ry="4" width="140" height="20" />
    <rect x="260" y="380" rx="4" ry="4" width="437" height="20" />
    <rect x="100" y="420" rx="4" ry="4" width="140" height="20" />
    <rect x="260" y="420" rx="4" ry="4" width="437" height="20" />
    <rect x="100" y="460" rx="4" ry="4" width="140" height="20" />
    <rect x="260" y="460" rx="4" ry="4" width="437" height="20" />
  </ContentLoader>
)

export default MyContentLoader
